/**
 * This file was automatically generated by an automated script. Do not edit manually.
 */
import type { ModelProfile } from "@langchain/core/language_models/profile";
const PROFILES: Record<string, ModelProfile> = {
  "gemini-embedding-001": {
    maxInputTokens: 2048,
    imageInputs: false,
    audioInputs: false,
    pdfInputs: false,
    videoInputs: false,
    maxOutputTokens: 3072,
    reasoningOutput: false,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: false,
    structuredOutput: false,
  },
  "gemini-2.5-flash-preview-05-20": {
    maxInputTokens: 1048576,
    imageInputs: true,
    audioInputs: true,
    pdfInputs: true,
    videoInputs: true,
    maxOutputTokens: 65536,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
  },
  "gemini-flash-lite-latest": {
    maxInputTokens: 1048576,
    imageInputs: true,
    audioInputs: true,
    pdfInputs: true,
    videoInputs: true,
    maxOutputTokens: 65536,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
  },
  "gemini-2.5-flash": {
    maxInputTokens: 1048576,
    imageInputs: true,
    audioInputs: true,
    pdfInputs: true,
    videoInputs: true,
    maxOutputTokens: 65536,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
  },
  "gemini-flash-latest": {
    maxInputTokens: 1048576,
    imageInputs: true,
    audioInputs: true,
    pdfInputs: true,
    videoInputs: true,
    maxOutputTokens: 65536,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
  },
  "gemini-2.5-pro-preview-05-06": {
    maxInputTokens: 1048576,
    imageInputs: true,
    audioInputs: true,
    pdfInputs: true,
    videoInputs: true,
    maxOutputTokens: 65536,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
  },
  "gemini-2.0-flash-lite": {
    maxInputTokens: 1048576,
    imageInputs: true,
    audioInputs: true,
    pdfInputs: true,
    videoInputs: true,
    maxOutputTokens: 8192,
    reasoningOutput: false,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
  },
  "gemini-2.0-flash": {
    maxInputTokens: 1048576,
    imageInputs: true,
    audioInputs: true,
    pdfInputs: true,
    videoInputs: true,
    maxOutputTokens: 8192,
    reasoningOutput: false,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
  },
  "gemini-2.5-flash-lite": {
    maxInputTokens: 1048576,
    imageInputs: true,
    audioInputs: true,
    pdfInputs: true,
    videoInputs: true,
    maxOutputTokens: 65536,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
  },
  "gemini-2.5-pro-preview-06-05": {
    maxInputTokens: 1048576,
    imageInputs: true,
    audioInputs: true,
    pdfInputs: true,
    videoInputs: true,
    maxOutputTokens: 65536,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
  },
  "gemini-2.5-flash-lite-preview-06-17": {
    maxInputTokens: 65536,
    imageInputs: true,
    audioInputs: true,
    pdfInputs: true,
    videoInputs: true,
    maxOutputTokens: 65536,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
  },
  "gemini-2.5-flash-preview-09-2025": {
    maxInputTokens: 1048576,
    imageInputs: true,
    audioInputs: true,
    pdfInputs: true,
    videoInputs: true,
    maxOutputTokens: 65536,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
  },
  "gemini-2.5-flash-preview-04-17": {
    maxInputTokens: 1048576,
    imageInputs: true,
    audioInputs: true,
    pdfInputs: true,
    videoInputs: true,
    maxOutputTokens: 65536,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
  },
  "gemini-2.5-pro": {
    maxInputTokens: 1048576,
    imageInputs: true,
    audioInputs: true,
    pdfInputs: true,
    videoInputs: true,
    maxOutputTokens: 65536,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
  },
  "gemini-2.5-flash-lite-preview-09-2025": {
    maxInputTokens: 1048576,
    imageInputs: true,
    audioInputs: true,
    pdfInputs: true,
    videoInputs: true,
    maxOutputTokens: 65536,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
  },
};
export default PROFILES;
